/**
 * Shared Tailwind class constants for drawer tab navigation.
 *
 * Used by DrawerTabBar (NavLink-based) and ResultTab (button-based sub-tabs).
 * Centralising here avoids duplicating the same strings in both files.
 */

export const DRAWER_TAB_ACTIVE_CLASSES = 'border-blue-600 text-gray-900';

export const DRAWER_TAB_INACTIVE_CLASSES =
  'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700';

/**
 * Base classes shared by every tab link in DrawerTabBar.
 * ResultTab buttons add extra padding/focus styles on top of these.
 */
export const DRAWER_TAB_LINK_CLASSES =
  'inline-flex items-center border-b-2 px-1 pt-1 text-sm font-medium';
